import { render, staticRenderFns } from "./listar-unidades.vue?vue&type=template&id=f6a52d20"
import script from "./listar-unidades.vue?vue&type=script&lang=js"
export * from "./listar-unidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports